import { DateTime } from "luxon";
import { isUS } from "lib/market";

// Dates and times follow the market of the clinic, not the device. Each is a
// default plus a single US exception, so opening a new market needs no change
// here:
//
//   date  day first, abbreviated month ("26 Jun 1999");  US "Jun 26, 1999"
//   time  24-hour ("16:00");                             US "4:00 PM"
//
// Matches Doctor UI's DATE_ABBR and TIME variants.
//
// The locale is pinned because luxon otherwise takes month and meridiem names
// from the device locale: the same DateTime renders "26 juni 1999" and
// "4:00 em" on a Swedish-configured iPad.
const LOCALE = "en-US";

export function formatDate(
  date: DateTime,
  countryCode: string | undefined
): string {
  const pinned = date.setLocale(LOCALE);
  return isUS(countryCode)
    ? pinned.toFormat("MMM d, yyyy")
    : pinned.toFormat("d MMM yyyy");
}

export function formatTime(
  date: DateTime,
  countryCode: string | undefined
): string {
  const pinned = date.setLocale(LOCALE);
  return isUS(countryCode)
    ? pinned.toFormat("h:mm a")
    : pinned.toFormat("HH:mm");
}

export function formatTimeRange(
  start: DateTime,
  end: DateTime,
  countryCode: string | undefined
): string {
  return `${formatTime(start, countryCode)} - ${formatTime(end, countryCode)}`;
}
